<template>
	<b-modal ref="modal" hide-footer>
		<template v-slot:modal-title>{{ $t('pax.simulation_titre') }}</template>

		<form @submit.prevent="submitPrint">
			<div class="form-group">
				<label>{{ $t('monte.etalon') }}<sup>*</sup></label>
				<e-select
					v-model="stallion"
					track-by="horse_id"
					label="horse_nom"
					:placeholder="$t('monte.selectionnez_etalon')"
					:selectedLabel="$t('select.selectedLabel')"
					:options="stallions"
					:searchable="true"
					:allow-empty="false"
					:sortable="false"
					:loading="isLoading"
					:show-labels="false"
				>
					<template slot="noOptions">{{ $t('global.list_empty') }}</template>
				</e-select>
			</div>

			<div class="alert alert-warning" v-if="caracterisation_incomplete">
				{{ $t('pax.simulation_caracterisation_incomplete') }}
				<router-link :to="{ name: 'HorsePax', params: { horse_id: mare.horse_id } }">{{ $t('pax.completer_caracterisation') }}</router-link>
			</div>

			<div class="text-center mt-4">
				<b-button type="submit" variant="primary" class="rounded-pill" :disabled="stallion === null || processing">
					{{ $t('pax.lancer_simulation') }}
					<font-awesome-icon v-if="processing" :icon="['fas', 'spinner']" pulse />
					<font-awesome-icon v-else :icon="['fal', 'print']" />
				</b-button>
			</div>
		</form>
	</b-modal>
</template>


<script type="text/javascript">
	import PaxMixin from '@/mixins/Pax.js'

	export default {
		name: "PaxSimulationModal",
		mixins: [PaxMixin],
		props: {
			mare: { type: Object, required: true }
		},
		data() {
			return {
				stallion: null,
				stallions: [],
				mares_percents: {},
				isLoading: true,
				processing: false
			}
		},
		methods: {
			/**
			 * Ouvre la modale et repart d'un formulaire vierge : le contenu d'une b-modal n'étant
			 * pas rendu avant la première ouverture, la remise à zéro et le chargement du
			 * catalogue d'étalons se font ici.
			 */
			async open() {
				this.stallion = null
				this.isLoading = true
				this.$refs.modal.show()

				const [stallions, percents] = await Promise.all([
					this.getStallions(),
					this.getCaracterisationPercents()
				])

				// getStallions et getCaracterisationPercents renvoient null lorsque l'appel échoue
				this.stallions = stallions !== null ? stallions.sort((a, b) => a.horse_nom.localeCompare(b.horse_nom)) : []
				this.mares_percents = percents !== null ? percents : {}

				this.isLoading = false
			},

			/**
			 * Génère le PDF de simulation pour le couple, puis referme la modale en signalant
			 * à la liste appelante que l'historique est à recharger.
			 */
			async submitPrint() {
				this.processing = true
				try {
					const done = await this.printSimulationCroisement(this.mare, this.stallion)
					if(done) {
						this.$emit('submit')
						this.$refs.modal.hide()
					}
				}
				finally {
					// l'API rejette si la jument n'appartient pas au client : le spinner doit s'arrêter
					this.processing = false
				}
			}
		},

		computed: {
			/**
			 * Une caractérisation PAX partielle donne une simulation moins pertinente :
			 * on invite alors le client à la compléter.
			 * @return {Boolean}
			 */
			caracterisation_incomplete() {
				if(this.isLoading) {
					return false
				}

				const percent = this.mares_percents[this.mare.horse_id]
				return percent === undefined || percent < 100
			}
		}
	}
</script>
